import type { ICONS_MAP } from '@common/components/icon/_icon-service';

export type ShiftSourceIconType = keyof (typeof ICONS_MAP)['light'];

export function getShiftSourceDisplay(source: string | null | undefined): {
  label: string;
  icon: ShiftSourceIconType;
} {
  if (!source) return { label: 'Unknown Source', icon: 'shuffle' };

  return (
    shiftSourceDisplayMap[source as keyof typeof shiftSourceDisplayMap] || {
      label: source.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      icon: 'shuffle',
    }
  );
}

export const shiftSourceDisplayMap: Record<
  string,
  {
    label: string;
    icon: ShiftSourceIconType;
  }
> = {
  internal: {
    label: 'Manual',
    icon: 'hand',
  },
  internal_import: {
    label: 'CSV',
    icon: 'upload',
  },
  ukg: {
    label: 'UKG',
    icon: 'shuffle',
  },
  symplr: {
    label: 'Symplr',
    icon: 'shuffle',
  },
  workload_magic: {
    label: 'Workload',
    icon: 'slidersUp',
  },
};
